import $ from 'jquery';
import Backbone from 'backbone';
import template from '../templates/modal.html';

const doNotShowItAgainLabels = {
  es: 'No mostrar este mensaje de nuevo',
  en: 'Do not show this message again',
  it: 'Non mostrare più questo messaggio',
  pt: 'Não mostrar esta mensagem novamente',
  fr: 'Ne plus afficher ce message',
};

const NoticesModalView = Backbone.View.extend({
  events: {
    'click #noticeModal .close': 'closeAction',
  },
  initialize(options) {
    this.options = options || {};
  },
  render() {
    const { noticeData } = this.options;
    if (noticeData) {
      noticeData.showItAgainLabel = doNotShowItAgainLabels[noticeData.lang];
      this.$el.append(template(noticeData));
      $('#noticeModal').show();
    }
  },
  close() {
    $('#noticeModal').hide();
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.$el.empty().off();
  },
  closeAction() {
    const deleteNotice = $('#showNoticeAgain').is(':checked');
    this.close();
    if (this.options.closeCallback) {
      this.options.closeCallback({
        noticeData: this.options.noticeData,
        delete: deleteNotice,
      });
    }
  },
});

export default NoticesModalView;



/** WEBPACK FOOTER **
 ** ./src/views/modal.js
 **/